

import statsBg from '../../assets/images/about-us/stats-bg.webp'
import statsWatchFace from '../../assets/images/about-us/stats-watch-face.webp'
import rafPortrait from '../../assets/images/about-us/raf-portrait.webp'
import showroomPhoto1 from '../../assets/images/about-us/showroom-photo-1.webp'
import watchMacro1 from '../../assets/images/about-us/watch-macro-1.jpg'
import hermesBag1 from '../../assets/images/about-us/hermes-bag-1.jpg'
import watch1 from '../../assets/images/about-us/watch-1.jpg'
import watch2 from '../../assets/images/about-us/watch-2.jpg'
import loungeView from '../../assets/images/about-us/lounge-view.webp'
import showcaseWall from '../../assets/images/about-us/showcase-wall.webp'
import videoPreview from '../../assets/images/about-us/video-preview.webp'
import videoFile from '../../assets/images/about-us/video.mp4'

import "./AboutPage.css";
import Testimonials from '../SellWithUs/Testimonials/Testimonials'
import { useContext, useEffect, useRef, useState } from 'react'
import ContactBlock from './ContactBlock/ContactBlock'
import { ConfigContext } from '../../assets/contexts/configContext'
import PromoScroll from '../Main/Banners/PromoScroll/PromoScroll'
import TotalReviews from '../TotalReviews/TotalReviews'
import Stats from './Stats/Stats'

export default function AboutPage() {
    const videoRef = useRef(null);
    const [videoOk, setVideoOk] = useState(true);
    const config = useContext(ConfigContext)
    const { mainLayout, initialConstants } = config
    console.log({ mainLayout: mainLayout ? mainLayout.filter(i => i.type === "promo-banner-scroll") : null })
    // Nudge autoplay on mobile/iOS and when tab becomes visible again
    useEffect(() => {
        const v = videoRef.current;
        if (!v) return;

        const tryPlay = () => {
            v.play().catch(() => {
                // if autoplay blocked for any reason, keep muted and try once more shortly
                setTimeout(() => v.play().catch(() => { }), 250);
            });
        };

        // attempt immediately if metadata is ready, else on canplay
        if (v.readyState >= 2) tryPlay();
        v.addEventListener('canplay', tryPlay, { once: true });

        const onVisibility = () => {
            if (document.visibilityState === 'visible') tryPlay();
        };
        document.addEventListener('visibilitychange', onVisibility);

        return () => {
            v.removeEventListener('canplay', tryPlay);
            document.removeEventListener('visibilitychange', onVisibility);
        };
    }, []);

    return (
        <main className="about">
            {/* ================= HERO ================= */}
            <section className="about__hero">
                <div className="about__hero-media">
                    <div className='about__hero-gradient' />
                    {videoOk ? (
                        <video
                            ref={videoRef}
                            className="about__hero-bg about__hero-video"
                            poster={videoPreview}
                            autoPlay
                            muted
                            playsInline
                            loop
                            preload="auto"
                            controls={false}
                            disablePictureInPicture
                            onError={() => setVideoOk(false)}
                        >
                            <source src={videoFile} type="video/mp4" />
                            {/* If the browser can't play MP4, we'll fall back below */}
                        </video>
                    ) : (
                        <img
                            src={videoPreview}
                            alt="Showroom video cover"
                            className="about__hero-bg"
                        />
                    )}

                    <div className="about__hero-overlay">
                        <p className="about__hero-eyebrow">LUXURY WATCH DEALER LOCATED IN DUBAI</p>
                        <h1 className="about__hero-title">Sany Watches</h1>
                    </div>
                </div>
                <div className="about__brands">
                    {mainLayout && mainLayout.length > 0 && mainLayout.filter(i => i.type === "promo-banner-scroll").length > 0 ?
                        <PromoScroll item={mainLayout.filter(i => i.type === "promo-banner-scroll")[0]} />
                        : null}
                </div>
            </section>


            {/* =============== WELCOME =============== */}
            <section className="about__welcome">
                <div className="about__container">
                    <h2 className="about__welcome-h2">
                        Welcome <span>to Sany, where it’s all about time</span>
                    </h2>

                    <div className="about__welcome-grid">
                        <img className="about__welcome-main"
                            src={showroomPhoto1}
                            alt="Showroom"
                        />

                        <div className="about__welcome-right">
                            <p className="about__welcome-lead">
                                Founded <span>in&nbsp;2014, Sany was born from a&nbsp;simple but powerful idea: to&nbsp;share a&nbsp;passion for fine timepieces with the world. What began as&nbsp;a&nbsp;small dream has since grown into a&nbsp;name recognized by&nbsp;watch enthusiasts everywhere&mdash;a place where appreciation for beauty, precision, and heritage comes together.</span>
                            </p>

                            <div className="about__welcome-thumbs">
                                <img
                                    src={watchMacro1}
                                    alt="Watch macro"
                                    className="about__welcome-thumb"
                                />
                                <img
                                    src={hermesBag1}
                                    alt="Hermes bag"
                                    className="about__welcome-thumb"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* =============== FOUNDER =============== */}
            <section className="about__founder">
                <div className="about__container about__founder-grid">
                    <img className="about__founder-photo"
                        src={rafPortrait}
                        alt="Rafael portrait"
                    />

                    <div className="about__founder-copy">
                        <p className="about__founder-text">
                            Inspired <span>by&nbsp;his family&rsquo;s legacy in&nbsp;jewelry and driven by&nbsp;his own love for horology, Rafael founded Sany to&nbsp;connect people with watches that are more than accessories. Each piece is&nbsp;chosen not only for its craftsmanship, but for the story it&nbsp;tells and the feeling it&nbsp;brings to&nbsp;its owner.</span>
                        </p>
                        <div className='about__founder-title'>
                            <h3 className="about__founder-name">RAFAEL</h3>
                            <p className="about__founder-role">FOUNDER OF SANY</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* =============== WITH (vision) =============== */}
            <section className="about__with">
                <div className="about__container">
                    <div className="about__with-grid">
                        <img className="about__with-card"
                            src={watch1}
                            alt="Luxury bag left"
                        />

                        <div className="about__with-copy">
                            <h3 className="about__with-title">
                                <span className="about__with-title-em">Trusted</span> by&nbsp;collectors and first-time buyers alike, Sany has become a&nbsp;destination for those seeking the rarest brands and most sought-after models. Every watch we&nbsp;source reflects our belief that luxury should be&nbsp;timeless&mdash;an investment in&nbsp;style, identity, and history that lives well beyond its first wearer.
                            </h3>
                        </div>

                        <img className="about__with-card"
                            src={watch2}
                            alt="Luxury bag right"
                        />
                    </div>
                </div>
            </section>

            {/* =============== WHAT (story + gallery) =============== */}
            <section className="about__what">
                <div className="about__container">
                    <div className="about__what-top">
                        <div className="about__what-copy">
                            <h3 className="about__what-heading">
                                <span className="about__what-heading-em">Every</span> watch tells a&nbsp;story. At&nbsp;Sany, we&nbsp;believe it&nbsp;is&nbsp;more than a&nbsp;way to&nbsp;mark time&mdash;it is&nbsp;a&nbsp;way to&nbsp;celebrate milestones, carry artistry, and embrace tradition. Whether you are building a&nbsp;collection or&nbsp;discovering your very first piece, our mission is&nbsp;to&nbsp;make that journey unforgettable.
                            </h3>
                            <img className="about__what-photo"
                                src={loungeView}
                                alt="Lounge interior"
                            />
                        </div>

                        <img className="about__what-hero"
                            src={showcaseWall}
                            alt="Showcase wall"
                        />
                    </div>

                </div>
            </section>
            <Testimonials className={'about__reviews'} />
            <TotalReviews />
            {/* =============== STATS =============== */}
            <Stats />
            <div className="about__container">
                <ContactBlock />
            </div>


        </main >
    );
}
